import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import io from "socket.io-client";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";

// Custom icon for markers (Avatar)
const createCustomIcon = (avatarUrl) => {
  return new L.Icon({
    iconUrl: avatarUrl,
    iconSize: [40, 40], // Adjust size
    iconAnchor: [20, 40], // Positioning
    popupAnchor: [0, -40],
  });
};

const getLocationName = async (latitude, longitude) => {
  try {
    const response = await axios.get(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    return response.data.display_name || "Unknown Location";
  } catch (error) {
    console.error("Error fetching location name:", error);
    return "Unknown Location";
  }
};

const Location = () => {
  const token = Cookies.get("authToken"); // Get token from cookies
  const [data, setData] = useState([]); // State to store real-time data

  // Sri Lanka's center coordinates
  const sriLankaCenter = [7.8731, 80.7718];

  useEffect(() => {
    const socket = io("https://faapi.diproit.com", {
      auth: { token: token },
      transports: ["websocket", "polling"],
    });

    socket.on("connect", () => {
      console.log("WebSocket connection established ✅");
    });

    socket.on("connect_error", (error) => {
      console.error("WebSocket connection error:", error);
    });

    const handleNewLocation = async (newLocation) => {
      const locationName = await getLocationName(newLocation.latitude, newLocation.longitude);
      console.log("Schedule table updated");

      setData((prevData) => [
        ...prevData,
        {
          lat: newLocation.latitude,
          lng: newLocation.longitude,
          message: newLocation.message || "Schedule Updated",
          avatar: newLocation.avatar || "https://cdn-icons-png.flaticon.com/512/684/684908.png",
          tsoName: newLocation.tso_full_name || "Unknown TSO",
          scheduleId: newLocation.schedule_id,
          locationName: locationName,
        },
      ]);
    };

    socket.on("schedule_added", handleNewLocation);

    return () => {
      socket.disconnect();
    };
  }, [token]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1>TSO LOCATOR</h1>

      {/* Sri Lanka Map */}
      <MapContainer
        center={sriLankaCenter}
        zoom={7}
        style={{ height: "500px", width: "80%", margin: "auto", borderRadius: "10px", overflow: "hidden" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {/* Real-time markers from WebSocket updates */}
        {data.map((item, index) => (
          <Marker key={`live-${index}`} position={[item.lat, item.lng]} icon={createCustomIcon(item.avatar)}>
            <Popup>
              <div style={{ textAlign: "center" }}>
                <img src={item.avatar} alt="Avatar" width="50" height="50" style={{ borderRadius: "50%" }} />
                <p><strong>{item.message}</strong></p>
                <p><strong>TSO Name:</strong> {item.tsoName}</p>
                <p><strong>Location:</strong> {item.locationName}</p>
                <p><strong>Latitude:</strong> {item.lat}</p>
                <p><strong>Longitude:</strong> {item.lng}</p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      {/* Real-time data messages */}
      {/* <div style={{ marginTop: "20px" }}>
        {data.map((item, index) => (
          <p key={index}>
            <strong>{item.message}</strong> - {item.tsoName} (Lat: {item.lat}, Lng: {item.lng})
          </p>
        ))}
      </div> */}
    </div>
  );
};

export default Location;
